export default __webpack_public_path__ + "static/MENUPDF-8cd96478f285105dc30cc334b0f9233a.pdf";